export const getAllCompanyLocationsEndpoint = 'company-locations';
